module.exports = __webpack_public_path__ + "638fa29c3f6183b0c797990256263941.svg";